import styled from 'styled-components';
import { space, variant, border, color, typography, flexbox, position, layout } from 'styled-system';
import css from '@styled-system/css';
import { StyledProps } from 'types/styles';

interface Props extends StyledProps {
  variant?: string;
  error?: boolean;
  passwordConfirmed?: boolean;
}

export const Wrapper = styled.div<Props>`
  ${flexbox}
  ${position}
  ${layout}
  ${space}
`;

export const InputWrapper = styled('input')<Props>(
  {
    fontFamily: 'inherit',
    display: 'flex',
    fontSize: '14px',
    border: 'none',
    outline: 'none',
  },
  border,
  color,
  space,
  layout,
  variant({
    variants: {
      primary: {
        borderRadius: 3,
        px: 3,
        border: '1px solid',
        borderColor: 'grays.3',
        backgroundColor: 'whites.0',
        '&:disabled': {
          backgroundColor: 'grays.4',
          borderColor: 'grays.4',
        },
        '&:focus': {
          borderColor: 'bluesV2.6',
        },
      },
      underline: {
        borderBottom: '1px solid',
        borderBottomColor: 'transparent',
        '&:hover': {
          borderBottomColor: 'greens.2',
          transition: 'all 0.2s ease-in-out 0s',
        },
        '&:focus': {
          borderBottomColor: 'greens.2',
          transition: 'all 0.2s ease-in-out 0s',
        },
      },
      outline: {
        border: '1px solid',
        borderColor: 'grays.3',
        px: 3,
        '&:hover': {
          borderColor: 'greens.2',
          transition: 'all 0.2s ease-in-out 0s',
        },
        '&:focus': {
          borderColor: 'greens.2',
          boxShadow: 'inputInset',
          transition: 'all 0.2s ease-in-out 0s',
        },
        '&:disabled': {
          backgroundColor: 'grays.4',
          borderColor: 'grays.4',
        },
      },
    },
  }),
  props => props.error && css({ borderColor: 'reds.0' }),
  props => props.passwordConfirmed && css({ borderColor: 'greens.2' }),
);

InputWrapper.defaultProps = {
  height: '36px',
  borderRadius: 3,
  width: '100%',
};

export const LabelWrapper = styled.label<Props>`
  ${color}
  ${typography}
  ${space}
`;

export const PencilIconWrapper = styled.div<Props>`
  ${layout}
  ${position}
  ${color}

  ${Wrapper}:hover & {
    display: flex;
  }

  svg {
    width: 16px;
  }
`;

export const EyeIconWrapper = styled.div<Props>`
  ${layout}
  ${position}
  ${color}

  ${Wrapper}:hover & {
    display: flex;
  }

  svg {
    width: 16px;
  }
`;

EyeIconWrapper.defaultProps = {
  height: '40px',
};

export const DescriptionWrapper = styled.div<Props>`
  ${color}
  ${typography}
  ${space}
`;

DescriptionWrapper.defaultProps = {
  color: 'glassDark.9',
  fontSize: 1,
  mb: 3,
};
